import React, { useState, useEffect, StrictMode } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WebWorkspace from "./components/WebWorkspace";
import WebPartnersCommunity from "./components/WebPartnersCommunity";
import WebTheIndependent from "./components/WebTheIndependent";
import WebSupport from "./components/WebSupport";
import WebSignupTemp from "./components/WebSignupTemp";
import WebRoadmap from "./components/WebRoadmap";
import WebLogin from "./components/WebLogin";
import WebGallery from "./components/WebGallery";
import WebFiles from "./components/WebFiles";
import WebDemo from "./components/WebDemo";
import WebHomepage from "./components/WebHomepage";
import WebHomepage2 from "./components/WebHomepage2";
import WebHomepage2B from "./components/WebHomepage2B";
import WebHomepage3 from "./components/WebHomepage3";
import WebHomepage3B from "./components/WebHomepage3B";
import TestPage from "./test";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WebHomepage />}/>
        <Route path="/home2" element={<WebHomepage2 />} />
        <Route path="/home2b" element={<WebHomepage2B />} />
        <Route path="/home3" element={<WebHomepage3 />} />
        <Route path="/home3b" element={<WebHomepage3B />} />
        {/* WebWorkspace route */}
        <Route path="/workspace" element={<WebWorkspace />} />
        {/* WebPartnersCommunity route */}
        <Route path="/partners-community" element={<WebPartnersCommunity />} />
        {/* WebTheIndependent route */}
        <Route path="/the-independent" element={<WebTheIndependent />} />
        {/* WebSupport route */}
        <Route path="/support" element={<WebSupport />} />
        {/* WebSignupTemp route */}
        <Route path="/signup" element={<WebSignupTemp />} />
        {/* WebRoadmap route */}
        <Route path="/roadmap" element={<WebRoadmap />} />
        {/* WebLogin route */}
        <Route path="/login" element={<WebLogin />} />
        {/* WebGallery route */}
        <Route path="/gallery" element={<WebGallery />} />
        {/* WebFiles route */}
        <Route path="/files" element={<WebFiles />} />
        {/* WebDemo route */}
        <Route path="/demo" element={<WebDemo />} />
        
        {/* /test route with backend message */}
        <Route path="/test" element={<TestPage />} />
      </Routes>
    </Router>
  );
}

export default App;
